import { useEffect, useState } from 'react'
import { useUser } from '../../../auth'
import { searchYearForAnalytics } from '../../../server/server'

// The backend resolves each school's role model. Numeric role IDs are not
// comparable across institutions, and coverage text is not a capability.
export default function useYearAnalyticsAccess() {
    const { user } = useUser()
    const [canAccess, setCanAccess] = useState(false)
    useEffect(() => {
        let active = true
        setCanAccess(false)
        if (user?.id) {
            searchYearForAnalytics({ searchText: '', loadedData: 0 }).then((response) => {
                if (active) setCanAccess(response.status === 200 && response.data?.canAccess === true)
            })
        }
        return () => { active = false }
    }, [user?.id, user?.role, user?.institution_id])
    return canAccess
}
